import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    gap: 20px;
    flex-direction: column;
    flex: 1;
    padding-bottom: 30px;
`